import { updateEndpoints } from '../config/api/Endpoints';
import { IMockProps } from '../types';
import { MOCK_ENDPOINT } from './constants';

export default class Mocks {
  private static instance: Mocks;
  private mocks: IMockProps[];

  private constructor() {
    this.mocks = [];
  }

  public static getInstance(): Mocks {
    if (!Mocks.instance) {
      Mocks.instance = new Mocks();
    }

    return Mocks.instance;
  }

  public add(mockProps: IMockProps): void {
    this.mocks.push(mockProps);
  }

  public addAll(mockProps: IMockProps[]): void {
    this.mocks = this.mocks.concat(mockProps);
  }

  public getAll(): IMockProps[] {
    return this.mocks;
  }

  public updateEndpoints(endPointsName: readonly string[]): void {
    updateEndpoints(
      'MOCK',
      endPointsName.map((name) => {
        return {
          ...MOCK_ENDPOINT,
          name,
        };
      }),
    );
  }
}
